<template>
    <div class="layer_pop_wrap">
        <div class='layer_pop_dim' style="background: rgba(0, 0, 0, 0);" :style="active? 'display: block;' : 'display: none'">
            <div class="layer_pop sm" :class="active? 'active' : ''" data-role-popup="modal_01" tabindex="0">
                <div class="pop_head">
                    <h2>활용 및 사전 등록/수정</h2>
                    <button type="button" class="pop_close" @click="close()">닫기</button>
                </div>
                <div class="pop_cont">
                    <div class="form_cont">
                        <br/>
                        <h3>재료, 목적, 장비 노드중 한개 이상이 달라 연결이 불가능합니다.</h3>
                        <br/>
                        <span>활용</span><div class="tooltip_box"> <span class="tooltip_ico"></span><div class="tooltip_txt"><p>기존 프로토콜을 활용하여 새로운 프로토콜을 생성하는 기능입니다.</p></div></div>
                        <span>또는 사전 등록/수정</span><div class="tooltip_box"> <span class="tooltip_ico"></span><div class="tooltip_txt"><p>사전에 해당 재료/목적/장비를 등록 또는 수정하여 프로토콜과 연결을 완료할 수 있습니다.</p></div></div>
                        <br/>
                        <h3>하시겠습니까?</h3>
                        <br/>
                        <br/>
                    </div>
                    <div class="pop_foot">
                        <button type="button" class="pop_btn" @click="$emit('utilizeProtocol',null)">활용하기</button>
                        <button type="button" class="pop_btn" @click="$emit('openModifyTagLayerPopup',null)">사전 등록/수정하기</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>

    export default {
        props: {
            active: {
                type: Boolean,
                default: false,
            },
            html: {
                type: String,
                default: "",
            }
        },
        watch: {
            active(bool) {
                if (bool) {
                    this.init();
                }
            }
        },
        computed: {
        },
        data() {
            return {}
        },
        methods: {
            init() {
            },
            close() {
                this.$emit('update:active', false);
            }
        }
    }
</script>
<style lang="scss" scoped>
</style>